/* eslint-disable @typescript-eslint/no-explicit-any */
export const registrations = [
    {
        name: 'GlobalStyles',
        import: () => import('@stories/Widgets/Global/GlobalStyles/GlobalStyles'),
        config: {
            hydrate: 'eager',
        },
    },
    {
        name: 'Error',
        import: () => import(/* webpackChunkName: 'Error' */ '@stories/Widgets/Global/Error/Error'),
        config: {
            hydrate: 'eager',
        },
    },
    {
        name: 'FormStyles',
        import: () => import('@stories/Widgets/Form/Form.styles'),
        config: {
            hydrate: 'eager',
        },
    },
    {
        name: 'RichTextStyles',
        import: () => import('@stories/Widgets/RichText/RichText.styles'),
        config: {
            hydrate: 'eager',
        },
    },
    {
        name: 'EventPromoBanner',
        import: () => import(/* webpackChunkName: 'EventPromoBanner' */ '@stories/Widgets/EventPromoBanner/EventPromoBanner'),
        config: {
            hydrate: 'eager',
        },
    },
    {
        name: 'Header',
        import: () => import(/* webpackChunkName: 'Header' */ '@stories/Widgets/Global/Header/Header'),
        config: {
            hydrate: 'eager',
        },
    },
    {
        name: 'HeroBanner',
        import: () => import(/* webpackChunkName: 'HeroBanner' */ '@stories/Widgets/HeroBanner/HeroBanner'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'AnchorTabs',
        import: () => import(/* webpackChunkName: 'AnchorTabs' */ '@stories/Widgets/AnchorTabs/AnchorTabs'),
        config: {
            hydrate: 'eager',
        },
    },
    {
        name: 'ContentCarousel',
        import: () => import(/* webpackChunkName: 'ContentCarousel' */ '@stories/Widgets/ContentCarousel/ContentCarousel'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'SplitContent',
        import: () => import(/* webpackChunkName: 'SplitContent' */ '@stories/Widgets/SplitContent/SplitContent'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'AnimatedLogoStrip',
        import: () => import(/* webpackChunkName: 'AnimatedLogoStrip' */ '@stories/Widgets/AnimatedLogoStrip/AnimatedLogoStrip'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'Tables',
        import: () => import(/* webpackChunkName: 'Tables' */ '@stories/Widgets/Tables/Tables'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'InnerHeroBanner',
        import: () => import(/* webpackChunkName: 'InnerHeroBanner' */ '@stories/Widgets/InnerHeroBanner/InnerHeroBanner'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'AuthorsAndDownload',
        import: () => import(/* webpackChunkName: 'AuthorsAndDownload' */ '@stories/Widgets/RichText/AuthorsAndDownload/AuthorsAndDownload'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'InArticleNewsletterSignUp',
        import: () => import(/* webpackChunkName: 'InArticleNewsletterSignUp' */ '@stories/Widgets/InArticleNewsletterSignUp/InArticleNewsletterSignUp'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'NewsletterSignUp',
        import: () => import(/* webpackChunkName: 'NewsletterSignUp' */ '@stories/Widgets/NewsletterSignUp/NewsletterSignUp'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'Footer',
        import: () => import(/* webpackChunkName: 'Footer' */ '@stories/Widgets/Global/Footer/Footer'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'InteractiveSplit',
        import: () => import(/* webpackChunkName: 'InteractiveSplit' */ '@stories/Widgets/InteractiveSplit/InteractiveSplit'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'AccordionList',
        import: () => import(/* webpackChunkName: 'AccordionList' */ '@stories/Widgets/AccordionList/AccordionList'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ArticleListing',
        import: () => import(/* webpackChunkName: 'ArticleListing' */ '@stories/Widgets/ArticleListing/ArticleListing'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'PeopleList',
        import: () => import(/* webpackChunkName: 'PeopleList' */ '@stories/Widgets/PeopleList/PeopleList'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'LogoList',
        import: () => import(/* webpackChunkName: 'LogoList' */ '@stories/Widgets/LogoList/LogoList'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'MembersDirectory',
        import: () => import(/* webpackChunkName: 'MembersDirectory' */ '@stories/Widgets/MembersDirectory/MembersDirectory'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'StatsAndTestimonials',
        import: () => import(/* webpackChunkName: 'StatsAndTestimonials' */ '@stories/Widgets/StatsAndTestimonials/StatsAndTestimonials'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'Breadcrumbs',
        import: () => import(/* webpackChunkName: 'Breadcrumbs' */ '@stories/Widgets/Global/Breadcrumbs/Breadcrumbs'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'InPageSearchSortFilter',
        import: () => import(/* webpackChunkName: 'InPageSearchSortFilter' */ '@stories/Widgets/InPageSearchSortFilter/InPageSearchSortFilter'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'MediaGallery',
        import: () => import(/* webpackChunkName: 'MediaGallery' */ '@stories/Widgets/MediaGallery/MediaGallery'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'EventDetails',
        import: () => import(/* webpackChunkName: 'EventDetails' */ '@stories/Widgets/EventDetails/EventDetails'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'Agenda',
        import: () => import(/* webpackChunkName: 'Agenda' */ '@stories/Widgets/EventDetails/Agenda/Agenda'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'AgendaPdf',
        import: () => import(/* webpackChunkName: 'AgendaPdf' */ '@stories/Widgets/EventDetails/AgendaPdf/AgendaPdf'),
        config: {
            hydrate: 'eager',
        },
    },
    {
        name: 'SpeakerProfiles',
        import: () => import(/* webpackChunkName: 'SpeakerProfiles' */ '@stories/Widgets/EventDetails/SpeakerProfiles/SpeakerProfiles'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'Sponsors',
        import: () => import(/* webpackChunkName: 'Sponsors' */ '@stories/Widgets/EventDetails/Sponsors/Sponsors'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'Form',
        import: () => import(/* webpackChunkName: 'Form' */ '@stories/Widgets/Form/Form'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'CategoryListing',
        import: () => import(/* webpackChunkName: 'CategoryListing' */ '@stories/Widgets/CategoryListing/CategoryListing'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'StandaloneImage',
        import: () => import(/* webpackChunkName: 'StandaloneImage' */ '@stories/Widgets/StandaloneImage/StandaloneImage'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'EventListing',
        import: () => import(/* webpackChunkName: 'EventListing' */ '@stories/Widgets/EventListing/EventListing'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'CookieDeclaration',
        import: () => import(/* webpackChunkName: 'CookieDeclaration' */ '@stories/Widgets/CookieDeclaration/CookieDeclaration'),
        config: {
            hydrate: 'never',
        },
    },
    {
        name: 'GroupCategoryListing',
        import: () => import(/* webpackChunkName: 'GroupCategoryListing' */ '@stories/Widgets/GroupCategoryListing/GroupCategoryListing'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'WhoAttendsWhyAttend',
        import: () => import(/* webpackChunkName: 'WhoAttendsWhyAttend' */ '@stories/Widgets/WhoAttendsWhyAttend/WhoAttendsWhyAttend'),
        config: {
            hydrate: 'in-view',
        },
    },
];
